export const Center = [10.61010906, 56.15950977]
export const Extent = [120000, 5900000, 1000000, 6500000]
export const Resolutions = [1638.4, 819.2, 409.6, 204.8, 102.4, 51.2, 25.6, 12.8, 6.4, 3.2, 1.6, 0.8, 0.4, 0.2]
export const MatrixIds =
  ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13']
export const Size = [256, 256]
